<template>
  <div class="wrapper">
    <div class="list">
      <div v-if="isComparison" class="list__item list__item__header">
        <div class="list__item_name-wrapper">
          <span class="list__item-color"></span>
        </div>
        <div class="list__item-intermediate">
          <span>Traffic Ranking</span>
        </div>
        <div class="list__item-number">
          <span>
            Estimated Monthly Clicks
            <base-material-design-icon
              v-tooltip.top-start="{content: 'Estimated clicks based on ranking CTR * MSV of tracked keywords', delay: { show: 100, hide: 100 }, classes: 'rfx-tooltip-arrow'}"
              style="font-size:14px;vertical-align:top;" ref="iconQuestion" icon="questionCircle" />
          </span>
        </div>
        <div class="list__item-share">
          <span>First Page Monthly Impressions</span>
        </div>
      </div>
      <div class="list__item" v-for="(item, index) in data"
           :key="item.name"
           :class="{'list__item_accent': hasHeader && index === 0}">
        <div class="list__item_name-wrapper">
          <span class="list__item-color" :style="getItemColorClass(index)"></span>
          <span class="list__item-name" :title="item.name"
          v-bind:private-content="index === 0">{{item.name}}</span>
        </div>
        <div class="list__item-intermediate">
          <span>{{item.intermediate}}</span>
        </div>
        <div class="list__item-number">
          <span>{{item.value | roundNumber | commaDividedNumber}}</span>
        </div>
        <div v-if="isComparison" class="list__item-share">
          <span>{{item.share_of_voice | roundNumber | commaDividedNumber}}</span>
        </div>
      </div>
      <temsplate v-if="footerItem">
        <div class="list__item list__item-footer"
             :class="{'list__item-footer_borderless': isFooterBorderless}">
          <div class="list__item-footer-name">
            {{footerItem.name}}
          </div>
          <div class="list__item-footer-value">
            <span>{{footerItem.value | roundNumber | commaDividedNumber}}</span>
          </div>
        </div>
      </temsplate>
    </div>
    <BasePieChart :list="data" class="pie-chart"></BasePieChart>
  </div>
</template>

<script>
import _ from 'lodash'
import { allColors } from '@/common/BasePieChart'
import filters from '@/common/Filters'
// eslint-disable-next-line no-unused-vars
import BasePieChart from '../../../common/BasePieChart'
/**
 * Pie Chart component for different RankZone tabs
 * it's adapter for BasePieChart {@link BasePieChart}
 */
export default {
  name: 'PieChart',
  props: {
    isComparison: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      required: true
    },
    hasHeader: Boolean,
    footerItem: {
      name: String,
      value: String | Number
    }
  },
  computed: {
    charData () {
      return this.handlePropsData()
    },
    isFooterBorderless () {
      return (this.hasHeader && this.data.length === 1) ||
        (!this.hasHeader && this.data.length === 0)
    }
  },
  methods: {
    handlePropsData () {
      let clonedData = _.cloneDeep(this.data)
      return clonedData
    },
    getItemColorClass (index) {
      return { 'background-color': allColors[ index ] }
    }
  },
  filters: {
    roundNumber: filters.roundNumber,
    commaDividedNumber: filters.commaDividedNumber
  }

}
</script>

<style scoped lang="scss">

  .wrapper {
    display: flex;
    width: 100%;
  }

  .list {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__item {
      display: flex;
      justify-content: space-between;
      height: 30px;
      align-items: center;
      font-size: 12px;
      font-weight: 500;
      color: $rfx-dark-march;

      &__header {
        margin-bottom: 10px;
      }

      &-color {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: inline-block;
        margin: 0 10px 0 0;
        flex-shrink: 0;
      }

      &-share {
        flex: 0 0 70px;
        display: flex;
        justify-content: flex-end;
        padding-left: 15px;
        > span {
          text-align: right;
        }
      }

      &-number {
        flex: 0 0 70px;
        display: flex;
        justify-content: flex-end;
        padding-left: 15px;
        > span {
          text-align: right;
        }
      }

      &-intermediate {
        flex: 0 0 30px;
        text-align: right;
        > span {
          text-align: right;
        }
      }

      &-name {
        font-size: 12px;
        font-weight: 500;
        color: $rfx-dark-march;
        @include ellipsis
      }

      &_name-wrapper {
        height: 100%;
        display: flex;
        align-items: center;
        flex: 1 1;
        padding-right: 15px;
        overflow: hidden;
      }

      &_accent {
        border-bottom: 1px solid $rfx-light-steel;

        div:not(.list__item-intermediate) span {
          font-weight: bold;
        }

        span {
          color: $rfx-dark-march;
        }
      }

      &-footer {
        border-top: 1px solid $rfx-light-steel;
        font-weight: bold;
        color: $rfx-dark-march;

        &_borderless {
          border: none;
        }

        &-name {
          flex: 1 1;
          text-align: right;
        }

        &-value {
          padding-left: 15px;
          flex: 0 0 70px;
          text-align: right;
        }
      }
    }

    &__total {
      display: flex;
      justify-content: flex-end;
      color: $rfx-dark-grey;
      border-top: 1px solid $rfx-light-steel;
      height: 30px;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
    }
  }

  .pie-chart {
    width: 40%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
</style>
